.code-input{font-size:1rem}.sk-spinner{width:100px!important;height:100px!important}
/*# sourceMappingURL=confirmed-action.component-3SONTIFC.css.map */
